// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content[data-v-2f7d4280] {

    display: flex;

    flex-direction: column;

    align-items: center
}
.content .main-jumbo[data-v-2f7d4280] .jumbo__content {

    padding-bottom: 0
}
@media (min-width: 996px) {
.content .main-jumbo[data-v-2f7d4280] .jumbo__content {

        padding-bottom: 5rem
}
}
@media (max-height: 719px) {
.content .main-jumbo[data-v-2f7d4280] .jumbo__content {

        gap: 0.5rem;

        padding-left: 1.5rem;

        padding-right: 1.5rem;

        padding-top: 1.5rem
}
}
.content .main-jumbo__background[data-v-2f7d4280] {

    position: absolute;

    top: 0;

    bottom: 0;

    left: 0;

    right: 0;

    --tw-bg-opacity: 1;

    background-color: rgb(251 212 76 / var(--tw-bg-opacity))
}
.content .main-jumbo__moles[data-v-2f7d4280] {

    position: absolute;

    top: 0;

    bottom: 0;

    right: 0;

    left: -12.5rem;

    display: none
}
@media (min-width: 996px) {
.content .main-jumbo__moles[data-v-2f7d4280] {

        display: flex;

        background-color: transparent;

        background-image: linear-gradient(to right, var(--tw-gradient-stops));

        --tw-gradient-from: #F6A229 var(--tw-gradient-from-position);

        --tw-gradient-to: rgb(246 162 41 / 0) var(--tw-gradient-to-position);

        --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);

        --tw-gradient-to: #F2DA5D var(--tw-gradient-to-position)
}
}
@media (min-width: 1320px) {
.content .main-jumbo__moles[data-v-2f7d4280] {

        left: -5rem
}
}
@media (min-width: 1536px) {
.content .main-jumbo__moles[data-v-2f7d4280] {

        left: 0
}
}
.content .main-jumbo__claim[data-v-2f7d4280] {

    display: flex;

    flex-direction: column;

    align-items: center;

    row-gap: 1.5rem
}
@media (min-width: 768px) {
.content .main-jumbo__claim[data-v-2f7d4280] {

        min-width: 26rem
}
}
@media (min-width: 996px) {
.content .main-jumbo__claim[data-v-2f7d4280] {

        align-items: flex-start;

        padding-left: 3.5rem
}
}
.content .main-jumbo__claim__title[data-v-2f7d4280] {

    text-align: center
}
@media (min-width: 996px) {
.content .main-jumbo__claim__title[data-v-2f7d4280] {

        text-align: left
}
}
@media (max-height: 719px) {
.content .main-jumbo__claim__title[data-v-2f7d4280] {

        font-size: 2rem
}
}
.content .main-jumbo__claim__ctas[data-v-2f7d4280] {

    display: none;

    max-width: 18.75rem;

    flex-direction: column;

    row-gap: 1.5rem
}
@media (min-width: 996px) {
.content .main-jumbo__claim__ctas[data-v-2f7d4280] {

        display: flex
}
}
.content .main-jumbo__house[data-v-2f7d4280] {

    position: relative;

    margin-top: 3.5rem;

    display: none
}
@media (min-width: 996px) {
.content .main-jumbo__house[data-v-2f7d4280] {

        display: block
}
}
.content .main-jumbo__house__wrapper[data-v-2f7d4280] {

    display: flex;

    width: 100%;

    flex-direction: column;

    align-items: flex-end
}
.content .main-jumbo__static-house[data-v-2f7d4280] {

    position: relative;

    width: 100%;

    max-width: 28.625rem
}
@media (min-width: 996px) {
.content .main-jumbo__static-house[data-v-2f7d4280] {

        display: none
}
}
.content .main-mobile-ctas[data-v-2f7d4280] {

    display: flex;

    width: 21.5rem;

    flex-direction: column;

    row-gap: 1rem;

    padding: 1.5rem
}
@media (min-width: 996px) {
.content .main-mobile-ctas[data-v-2f7d4280] {

        display: none
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/MainJumbo.vue"],"names":[],"mappings":";AA+CA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAKA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,WAAA;;QAAA,oBAAA;;QAAA,qBAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,MAAA;;IAAA,SAAA;;IAAA,OAAA;;IAAA,QAAA;;IAAA,kBAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,MAAA;;IAAA,SAAA;;IAAA,QAAA;;IAAA,cAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,aAAA;;QAAA,6BAAA;;QAAA,qEAAA;;QAAA,4DAAA;;QAAA,oEAAA;;QAAA,mEAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,uBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,sBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAKA;;IAAA,kBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,WAAA;;IAAA,sBAAA;;IAAA;AAAA;AAKA;;IAAA,kBAAA;;IAAA,WAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAKA;;IAAA,aAAA;;IAAA,cAAA;;IAAA,sBAAA;;IAAA,aAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <div class=\"content\">\n    <!-- Home jumbo -->\n    <Jumbo class=\"main-jumbo\" :spaced=\"spaced\">\n      <template #background>\n        <div class=\"main-jumbo__background\">\n          <Moles :count=\"1\" :scale=\"3\" align=\"right\" background=\"transparent\" class=\"main-jumbo__moles\" reversed />\n        </div>\n      </template>\n\n      <template #before>\n        <div class=\"main-jumbo__claim\">\n          <div class=\"main-jumbo__claim__title\">\n            Alguien tenía <br />\n            que mejorar <br />\n            las hipotecas\n          </div>\n\n          <div class=\"main-jumbo__claim__ctas\">\n            <Button tag=\"a\" :href=\"route('funnel.new')\">Simular una nueva hipoteca</Button>\n            <Button tag=\"a\" :href=\"route('funnel.improve')\" btn-style=\"secondary\">Mejorar mi hipoteca actual</Button>\n          </div>\n        </div>\n      </template>\n\n      <template #after>\n        <div class=\"main-jumbo__house__wrapper\">\n          <HouseAnimation class=\"main-jumbo__house\" />\n          <ImageComponent\n            class=\"main-jumbo__static-house\"\n            src=\"img/web/banner/banner-mobile.webp\"\n            alt=\"La casa de tus sueños\"\n            width=\"916\"\n          ></ImageComponent>\n        </div>\n      </template>\n    </Jumbo>\n\n    <div class=\"main-mobile-ctas\">\n      <Button tag=\"a\" :href=\"route('funnel.new')\">Simular una nueva hipoteca</Button>\n      <Button tag=\"a\" :href=\"route('funnel.improve')\" btn-style=\"secondary\">Mejorar mi hipoteca actual</Button>\n    </div>\n  </div>\n</template>\n\n<style lang=\"postcss\" scoped>\n.content {\n  @apply flex flex-col items-center;\n\n  .main {\n    &-jumbo {\n      /deep/ .jumbo__content {\n        @apply pb-0 lg:pb-xxl short:px-xxs short:pt-xxs short:gap-nano;\n      }\n\n      &__background {\n        @apply absolute top-0 bottom-0 left-0 right-0 bg-brand-primary-light;\n      }\n\n      &__moles {\n        @apply hidden lg:flex absolute top-0 bottom-0 right-0 xl:-left-xxl -left-giant 2xl:left-0 lg:bg-transparent lg:bg-gradient-to-r lg:from-gradient-summer-start lg:to-gradient-summer-end;\n      }\n\n      &__claim {\n        @apply flex flex-col gap-y-xxs md:min-w-[26rem] items-center lg:items-start lg:pl-lg;\n\n        &__title {\n          @apply text-center lg:text-left short:text-xl;\n        }\n\n        &__ctas {\n          @apply hidden lg:flex flex-col gap-y-xxs max-w-[18.75rem];\n        }\n      }\n\n      &__house {\n        @apply relative hidden lg:block mt-lg;\n\n        &__wrapper {\n          @apply w-full flex flex-col items-end;\n        }\n      }\n\n      &__static-house {\n        @apply w-full max-w-[28.625rem] lg:hidden relative;\n      }\n    }\n\n    &-mobile-ctas {\n      @apply lg:hidden p-xxs flex flex-col gap-y-xxxs w-[21.5rem];\n    }\n  }\n}\n</style>\n\n<script>\nimport { onMounted, ref } from '@vue/composition-api';\nimport { onResize } from '@/lego/utils/window/screen';\nimport { getTouchedScreen } from '@/lego/utils/tailwind/screen';\nimport Jumbo from '@/lego/components/layout/Jumbo.vue';\nimport Moles from '@/lego/components/layout/Moles.vue';\nimport Button from '@/lego/components/buttons/Button.vue';\nimport ImageComponent from '@/lego/components/images/Image.vue';\nimport HouseAnimation from '@/lego/components/animations/House.vue';\n\nexport default {\n  components: {\n    Jumbo,\n    Moles,\n    Button,\n    ImageComponent,\n    HouseAnimation,\n  },\n  setup() {\n    const breakpoints = { xs: false, sm: true };\n    const spaced = ref(true);\n\n    const updateSize = () => {\n      const screen = getTouchedScreen(breakpoints);\n      spaced.value = breakpoints[screen];\n    };\n\n    onMounted(() => {\n      updateSize();\n    });\n    onResize(() => {\n      updateSize();\n    });\n\n    return {\n      spaced,\n    };\n  },\n};\n</script>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
